import { Component, OnInit, Input } from '@angular/core';
import { GastoService } from '../../../services/gasto.service';
import { Gasto } from '../../../models/gasto';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-gasto-modal',
  templateUrl: './gasto-modal.component.html',
  styleUrls: ['./gasto-modal.component.css'],
  providers: [GastoService]
})
export class GastoModalComponent implements OnInit {
  @Input() gasto_id: String;
  public gasto: Gasto;
  public loading = false;

  constructor(
    private gastoService: GastoService,
    public bsModalRef: BsModalRef,) { 
        this.gasto = new Gasto();
    }

  ngOnInit() {
    this.getGastoById();
  }

  getGastoById(){
    this.loading = true;
    let qs= "?embed=bodega,proveedor,detalle";
    this.gastoService.getById(this.gasto_id, qs).subscribe(
      res => {
        this.loading = false;
        this.gasto = res.data;
      },
      err => {
          this.loading = false;
      }
    );

  }

  getNumeroDocumento(gasto){
		return gasto.serie + "-" + gasto.punto_emision + "-" + gasto.secuencial;
  }
  
  getCreditoTributario(credito_tributario){
    if(credito_tributario=='S'){
      return "SI";
    }
    else{
      return "NO";
    }
  }

  getIva(iva){
    return iva > 0?"SI":"NO"
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/gasto-modal/gasto-modal.component.ts